var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83916 4.56003H5.5187C4.98845 4.56003 4.55859 4.98984 4.55859 5.52003V9.84004C4.55859 10.3702 4.98845 10.8 5.5187 10.8H9.83916C10.3694 10.8 10.7993 10.3702 10.7993 9.84004V5.52003C10.7993 4.98984 10.3694 4.56003 9.83916 4.56003Z",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63937 7.44002H2.15932C1.90469 7.44002 1.66048 7.33888 1.48043 7.15884C1.30037 6.97881 1.19922 6.73463 1.19922 6.48002V2.16001C1.19922 1.90541 1.30037 1.66123 1.48043 1.48119C1.66048 1.30115 1.90469 1.20001 2.15932 1.20001H6.47978C6.73442 1.20001 6.97862 1.30115 7.15868 1.48119C7.33873 1.66123 7.43988 1.90541 7.43988 2.16001V2.64001",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.cfe5b1e2c178a517ef01f0690a86a620.svg";
export { ForwardRef as ReactComponent };